"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAnalyticsPeriodFinish = exports.getAnalyticsPeriodStart = exports.setAnalyticsPeriod = exports.filterAccounts = exports.AccountsActionTypes = void 0;

var _keyMirror = _interopRequireDefault(require("react-utils/keyMirror"));

var _fluxActions = require("flux-actions");

var AccountsActionTypes = (0, _keyMirror.default)({
  FILTER_ACCOUNTS: null,
  SET_ANALYTICS_PERIOD: null,
  GET_ANALYTICS_PERIOD_START: null,
  GET_ANALYTICS_PERIOD_FINISH: null
});
exports.AccountsActionTypes = AccountsActionTypes;
var filterAccounts = (0, _fluxActions.createAction)(AccountsActionTypes.FILTER_ACCOUNTS, function (filter) {
  return {
    filter: filter
  };
});
exports.filterAccounts = filterAccounts;
var setAnalyticsPeriod = (0, _fluxActions.createAction)(AccountsActionTypes.SET_ANALYTICS_PERIOD, function (analyticsPeriod) {
  return {
    analyticsPeriod: analyticsPeriod
  };
});
exports.setAnalyticsPeriod = setAnalyticsPeriod;
var getAnalyticsPeriodStart = (0, _fluxActions.createAction)(AccountsActionTypes.GET_ANALYTICS_PERIOD_START);
exports.getAnalyticsPeriodStart = getAnalyticsPeriodStart;
var getAnalyticsPeriodFinish = (0, _fluxActions.createAction)(AccountsActionTypes.GET_ANALYTICS_PERIOD_FINISH, function (analyticsPeriod) {
  return {
    analyticsPeriod: analyticsPeriod
  };
});
exports.getAnalyticsPeriodFinish = getAnalyticsPeriodFinish;